var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 46,
    viewBox: "0 0 74 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5032 9.52551C48.5032 10.8012 48.7595 12.1435 48.9994 13.3913C49.2678 14.7871 49.2523 16.4625 49.0791 17.8697C48.8253 19.9313 48.8484 22.0634 48.7299 24.1371C48.5878 26.6239 48.7237 29.164 48.7237 31.6543C48.7237 34.9629 48.7299 40.7202 48.7299 44.033C48.834 45.1587 48.834 43.0288 48.834 42.6084C48.834 41.9242 48.834 41.2401 48.834 40.556C48.834 37.9915 48.402 35.4545 48.5093 32.8796C48.5766 31.2656 48.8747 29.7 49.1097 28.107C49.3614 26.4009 49.5643 24.7077 49.7407 22.9915C49.8867 21.5712 50.2257 20.1444 50.4882 18.7397C50.7705 17.2283 50.9688 15.6491 51.5848 14.2245C52.3942 12.3527 53.7951 10.9426 55.8182 10.518C56.9434 10.2818 58.1775 10.4077 59.3225 10.4077C60.7003 10.4077 61.8963 10.488 63.2189 10.9101C65.6451 11.6844 67.432 14.0595 68.4142 16.2891C69.576 18.9269 69.9689 21.5975 70.2889 24.4312C70.9739 30.4985 71.7715 36.6037 71.7715 42.7186",
    stroke: "#B00487",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88672 9.36467C2.88672 10.9131 3.0684 12.3512 3.26656 13.8799C3.48136 15.5369 3.4381 17.2652 3.4381 18.9342C3.4381 22.0528 3.4813 25.1831 3.3217 28.2954C3.06658 33.2701 2.99699 38.2326 2.99699 43.2194",
    stroke: "#4503B0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33594 1.64532C2.33594 1.8413 2.36657 1.92714 2.44621 2.08643",
    stroke: "#4503B0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/IN.c737805a673176b3a1d465f787409ab3.svg";
export { ForwardRef as ReactComponent };